var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("flex items-center font-medium text-14px app-form-reset px-2 " + _vm.getStatusTextClass)},[_vm._v(" "+_vm._s(_vm.getTripStatus)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }